/* eslint-disable camelcase */
export interface parserResponse {
  transformed_edi: JSON | null
  extracted_data: JSON
  schema_validation_result: boolean
  schema_validation_errors: [string[]]
  conversion_errors: [string]
  extraction_errors: string
  conversion_debug_logs: [string[]]
  valid: boolean
  final_output: JSON
}

export interface parserVersionRequest {
  configurable_parser_version: {
    edi_mapper_configurable_parser_id?: number
    is_live?: boolean
    extraction_template?: string
    conversion_instructions?: JSON
    stupidedi_config?: string
    edi_mapper_tfx12_definition_id?: string
    element_conversion?: string
    document_conversion?: string
    notes?: string
    parser_library?: string
  }
}

export interface parserRequest {
  configurable_parser: {
    name: string
  }
}

export interface runParserRequest {
  rawEdi?: string
  extractionTemplate?: string
  conversionInstructions?: string
  parserLibrary?: string
  stupidediConfig?: string
  ediMapperTfx12DefinitionId?: string
  elementConversion?: string
  documentConversion?: string
}

export interface tfx12Config {
  id: string
  reference: string
}

export interface ParserConfigs {
  documentConversions: [string]
  elementConversions: [string]
  stupidediConfigs: [string]
  tfx12Configs: [tfx12Config]
}

export interface Parser {
  id: number
  name: string
  parserVersions: ParserVersion[]
  createdAt: string
  updatedAt: string
}

export interface ParserVersion {
  parser_library: string
  config_type: string
  id: number
  edi_mapper_configurable_parser_id: number
  is_live: boolean
  was_ever_live: boolean
  stupidedi_config?: string
  edi_mapper_tfx12_definition_id?: string
  element_conversion: string
  document_conversion: string
  extraction_template: string
  conversion_instructions: JSON
  notes?: string
  parent_parser?: Parser
  version_number?: number
}

export interface MakeLiveErrorResponse {
  errors: string[]
}

export interface ParserTest {
  id: number
  edi_mapper_configurable_parser_id: number
  is_live: boolean
  name: string
  notes?: string
  edi_input: string
  expected_output: JSON
}

export interface ParserTestResult {
  actual_output: any
  diffs: [any[]]
  expected_output: any
  is_live: boolean
  name: string
  parsed_interchange: JSON
  passed: boolean
  status: string
  notes: string
}

export interface ParserTestRequest {
  configurable_parser_test: {
    edi_mapper_configurable_parser_id: number
    name: string
    edi_input: string
    expected_output: string
    is_live: boolean
    notes: string
  }
}

export interface IGetMarkdownResponse {
  markdown: string
}

export enum STEP_NAMES {
  TRANSFORMATION = 'transformation',
  EXTRACTION = 'extraction',
  CONVERSION = 'conversion',
}
